import ApiClient from "@/domain/core/utils/apiClient";
import client_core from "@/services/clients/client_core";

const client = new ApiClient(client_core)

const endpoints = {
    admin_payout_list: '/dashboard/v2/admin/payouts/',
    admin_payout_detail: '/dashboard/v2/admin/payouts/{id}/',
    admin_statistics: '/dashboard/v2/admin/payouts/statistics/',
    admin_mark_paid: '/dashboard/v2/admin/payouts/{id}/mark_paid/',
    admin_download_excel: '/dashboard/v2/admin/payouts/{id}/download_excel/',
    admin_delete: '/dashboard/v2/admin/payouts/{id}/',
    admin_generate: '/dashboard/v2/admin/payouts/generate/',
    admin_ps_download: '/dashboard/v2/admin/payouts/{id}/pica-service/{psId}/download/',
    admin_reject_invoice: '/dashboard/v2/admin/payouts/{id}/reject-invoice/',
}

export default {
    async fetchAdminPayoutList(filters, pagination, sorting) {
        let result = await client.get(endpoints.admin_payout_list, {
            ...filters,
            page_size: pagination.page_size ?? 20,
            page: pagination.page ?? 1,
            ordering: sorting.desc ? `-${sorting.column}` : sorting.column ?? '-created_at'
        })
        return {
            results: result.results,
            pagination: {
                num_pages: result.pagination.num_pages,
                page_size: result.pagination.page_size,
                page: result.pagination.page_number,
                total: result.pagination.total,
            }
        }
    },
    
    async fetchAdminPayoutDetail(id) {
        return await client.get(endpoints.admin_payout_detail.replace('{id}', id))
    },
    
    async markPayoutAsPaid(id, data = {}) {
        return await client.post(endpoints.admin_mark_paid.replace('{id}', id), data)
    },
    
    async downloadPayoutExcel(id) {
        return await client.download(endpoints.admin_download_excel.replace('{id}', id))
    },
    
    async fetchStatistics(contractManagerId) {
        return await client.get(endpoints.admin_statistics, {
            contract_manager__id: contractManagerId
        })
    },

    async deleteLastPayout(id) {
        return await client.delete(endpoints.admin_delete.replace('{id}', id))
    },

    async downloadPicaServiceExcel(payoutId, psId) {
        return await client.download(
            endpoints.admin_ps_download.replace('{id}', payoutId).replace('{psId}', psId)
        )
    },

    async rejectInvoice(id, reason) {
        return await client.post(endpoints.admin_reject_invoice.replace('{id}', id), { reason })
    },

    async generatePayout(contractManagerId) {
        return await client.post(endpoints.admin_generate, {
            contract_manager_id: contractManagerId
        })
    }
}